export default "__VITE_ASSET__BsJuwLvr__"